var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadclound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0646 13.5484H11.1553H10.3719H10.2027V9.6461H11.479C11.8026 9.6461 11.9939 9.27831 11.8026 9.01349L9.31998 5.57827C9.16183 5.35759 8.83449 5.35759 8.67634 5.57827L6.19371 9.01349C6.00245 9.27831 6.19003 9.6461 6.51737 9.6461H7.79362V13.5484H7.62444H6.84103H3.46833C1.53739 13.4418 0 11.6359 0 9.67921C0 8.32939 0.731917 7.15244 1.81692 6.51615C1.71761 6.24766 1.66612 5.96078 1.66612 5.65918C1.66612 4.27994 2.78055 3.16552 4.15979 3.16552C4.4577 3.16552 4.74459 3.21701 5.01308 3.31631C5.8112 1.62445 7.53249 0.451172 9.53331 0.451172C12.1226 0.45485 14.2558 2.43728 14.4986 4.96405C16.4884 5.3061 18 7.14876 18 9.23417C18 11.463 16.264 13.394 14.0646 13.5484Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadclound);
export default __webpack_public_path__ + "static/media/uploadclound.17c12bb949c0554a1e2cc8f739979eb5.svg";
export { ForwardRef as ReactComponent };